import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const PlayerProfileLink = ({
    player = {},
    isAFLW,
    classes,
    isExternal = false,
    children
}) => {
    const [playerURL, setPlayerURL] = useState('');

    useEffect(() => {
        if (player?.playerId) {
            PULSE.app.common.pulseId
                .getPlayerPulseId(player.playerId)
                .then((id) => {
                    setPlayerURL(
                        PULSE.app.common.url.getPlayerProfileURL(
                            {
                                firstName: player.firstName.toLowerCase(),
                                surname: player.surname.toLowerCase(),
                                id: id
                            },
                            isAFLW
                        )
                    );
                });
        }
    }, [player.playerId]);

    return playerURL ? (
        <a
            className={classes}
            href={playerURL}
            target={isExternal ? '_blank' : null}
            rel={isExternal ? 'noreferrer' : null}
        >
            {children}
        </a>
    ) : (
        <></>
    );
};

PlayerProfileLink.propTypes = {
    player: PropTypes.shape({
        playerId: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        surname: PropTypes.string.isRequired
    }).isRequired,
    isAFLW: PropTypes.bool,
    classes: PropTypes.string,
    children: PropTypes.any,
    isExternal: PropTypes.bool
};
